// Imports
import React from 'react';
import { GetResellersResponse } from '../../../shareables/types/api/main/self/resellers/get';


// Define what the context looks like
export type ContextDetails = GetResellersResponse[0] | null;


// Create context
const ResellerContext = React.createContext<ContextDetails>(null);

export default ResellerContext;
